import { injectable, injectFromBase } from 'inversify'
import { LocalStorageServiceBase } from '@/services/storage/localStorageServiceBase'
import type { LocalStorageServiceInterface } from '@/services/storage/types'

@injectable()
@injectFromBase()
export class SessionStorageService extends LocalStorageServiceBase implements LocalStorageServiceInterface {
  protected readonly storage = sessionStorage
}
